const useClient = (): boolean => {
  return typeof window !== 'undefined';
};

export default useClient;
